export default __webpack_public_path__ + "static/background-7f23acb673befbd5496f98a17e7bc373.png";